export const USER_TYPE_MAP = {
  "UTY1000001": "Individual",
  "UTY1000002": "HUF",
  "UTY1000003": "Company",
  "UTY1000004": "Proprietorship",
  "UTY1000005": "Private Limited",
  "UTY1000006": "Company",
  "UTY1000007": "Partnership Firm / LLP",
  "UTY1000008": "NBFC",
};

export const DEPOSIT_PAYLOAD_ORDER = [
  'orgId',
  'transactionId',
  'businessName',
  'investorName',
  'virtualAccountNumber',
  'utr',
  'amount',
  'purpose',
  'status',
  'isDuplicate',
  'duplicateOfTransactionId',
];

export const formatAction = (action) => {
  if (!action) return '';
  return action.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};

export const formatPayloadKey = (key) => {
  if (key === 'dealCategoryId') return 'Deal Category Name';
  if (key === 'busName' || key === 'businessName') return 'Name';
  return key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()).trim();
};

export const formatPayloadValue = (key, value, payload = {}) => {
  if (value === null || value === undefined || value === "") return "";
  if (typeof value === "object") return JSON.stringify(value);

  if (key === "purpose") {
    let text = String(value).trim().replace(/\brecived\b/gi, "received");
    text = text.toLowerCase().replace(/\b\w/g, (ch) => ch.toUpperCase());
    if (payload?.txnChannel) {
      text = `${text} (${String(payload.txnChannel).trim().toUpperCase()})`;
    }
    return text;
  }

  const strVal = String(value).trim();

  if (key === "investorTypeId" || key === "userTypeId" || key === "businessTypeId") {
    return USER_TYPE_MAP[strVal] || strVal;
  }

  if (key === "discountRate" || key === "annualDiscountRate" || key === "maxFundRequiredPct") {
    const cleanStr = strVal.replace(/%/g, "").trim();
    const num = parseFloat(cleanStr);
    if (!isNaN(num)) {
      const percentage = (num > 0 && num <= 1) ? num * 100 : num;
      const rounded = Number.isInteger(percentage) ? percentage : parseFloat(percentage.toFixed(2));
      return `${rounded}%`;
    }
    return strVal.endsWith("%") ? strVal : `${strVal}%`;
  }

  if (
    key === "amount" ||
    key === "creditExposure" ||
    key === "requestedCredit" ||
    key === "approvedCredit" ||
    key === "newCredit" ||
    key === "currentCredit" ||
    key === "creditLimit" ||
    key === "approvedAmt" ||
    key === "invoiceAmount" ||
    key === "totalInvoiceValue" ||
    key === "fundRequired" ||
    key === "fundedAmt" ||
    key === "disbursedAmt" ||
    key === "settledAmt" ||
    key === "balanceAmt" ||
    key === "stampFee"
  ) {
    const num = Number(strVal.replace(/,/g, ""));
    if (!isNaN(num)) {
      return num.toLocaleString("en-IN");
    }
  }

  if (key === "manual" || key === "isDuplicate" || key === "fullySettled") {
    return strVal === "true" || value === true ? "Yes" : "No";
  }

  return strVal;
};
